import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  makeSyncReduxWithLocalStorageObserver,
  restoreFromLocalStorage,
} from 'app/dataManagement/syncReduxStateWithLocalStorage';
import observeStore from 'app/utils/redux/observeStore';

export const CLINIC_INFO_LOCAL_STORAGE_KEY = 'redux.clinicInfo';

export type ClinicInfo = {
  address: string;
  postCode: string;
  city: string;
  country: string;
  workplaceName: string;
} | null;

const defaultState: ClinicInfo = null;
const initialState: () => ClinicInfo = () =>
  restoreFromLocalStorage(CLINIC_INFO_LOCAL_STORAGE_KEY, defaultState);
const clinicInfoSlice = createSlice({
  name: 'clinicInfo',
  initialState,
  reducers: {
    setClinicInfo(state, action: PayloadAction<ClinicInfo>) {
      return action.payload;
    },
    clearClinicInfo() {
      return null;
    },
  },
});
export const { setClinicInfo, clearClinicInfo } = clinicInfoSlice.actions;
export type StoreWithClinicInfo = { clinicInfo: ClinicInfo };
export const selectClinicInfo = (state: StoreWithClinicInfo) => state.clinicInfo;
export const attachClinicInfoWithLocalStorageSynchronizationObserver = (
  store: StoreWithClinicInfo
) => {
  observeStore(
    store,
    selectClinicInfo,
    makeSyncReduxWithLocalStorageObserver(CLINIC_INFO_LOCAL_STORAGE_KEY)
  );
};
export default clinicInfoSlice.reducer;
